import { Typography } from '@components/Typography';
import { formatNumber, formatPercentNumber } from '@helpers/formatNumbers';
import { useTranslation } from '@hooks';
import { getTableArrow, TableCellText, Text } from '.';

export const GetTableBody = (data, isQr) => {
    const { t } = useTranslation();
    return data.map(
        (
            {
                internalName,
                surveyTemplateId,
                sentSurveys,
                responsesReceived,
                responsesReceivedPercent,
                responsesReceivedChange,
                leaveReviewClicked,
                leaveReviewClickedPercent,
                leaveReviewClickedChange,
                openedSurveys,
                openedSurveysPercent,
                openedSurveysChange,
                reviewsReceived,
                reviewsReceivedChange,
            },
            index,
        ) => {
            return !surveyTemplateId
                ? [
                      {
                          component: (
                              <Typography variant="subtitle2" align="left" sx={{ minWidth: '100px' }}>
                                  {index === data.length - 1 ? t('AnalyticsConversion.overall') : internalName}
                              </Typography>
                          ),
                      },
                      {
                          component: (
                              <Typography variant="body2" align="right" sx={{ minWidth: '89px' }}>
                                  {!isQr ? formatNumber(sentSurveys) : formatNumber(openedSurveys)}
                              </Typography>
                          ),
                      },
                      ...(!isQr
                          ? [
                                {
                                    component: (
                                        <TableCellText variant="body2" align="right" sx={{ minWidth: '89px' }}>
                                            {formatNumber(openedSurveys)}
                                            <Text withIcon={openedSurveysChange}>
                                                ({formatPercentNumber(openedSurveysPercent)})
                                            </Text>
                                            {getTableArrow(openedSurveysChange)}
                                        </TableCellText>
                                    ),
                                },
                            ]
                          : []),
                      {
                          component: (
                              <TableCellText variant="body2" align="right" sx={{ minWidth: '89px' }}>
                                  {formatNumber(responsesReceived)}
                                  <Text withIcon={responsesReceivedChange}>
                                      ({formatPercentNumber(responsesReceivedPercent)})
                                  </Text>
                                  {getTableArrow(responsesReceivedChange)}
                              </TableCellText>
                          ),
                      },
                      {
                          component: (
                              <TableCellText variant="body2" align="right" sx={{ minWidth: '89px' }}>
                                  {formatNumber(leaveReviewClicked)}
                                  <Text withIcon={leaveReviewClickedChange}>
                                      ({formatPercentNumber(leaveReviewClickedPercent)})
                                  </Text>
                                  {getTableArrow(leaveReviewClickedChange)}
                              </TableCellText>
                          ),
                      },
                      {
                          component: (
                              <TableCellText variant="body2" align="right" sx={{ minWidth: '89px' }}>
                                  {formatNumber(reviewsReceived)}
                                  <Text withIcon={reviewsReceivedChange} />
                                  {getTableArrow(reviewsReceivedChange)}
                              </TableCellText>
                          ),
                      },
                  ]
                : null;
        },
    );
};
